import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {History} from "./History";

window.addEventListener('DOMContentLoaded',async () =>
{
    // set variables
    Basic.init();

    // first history entry
    History.replace_url();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
    }

    // add event listeners
    Basic.add_changeEvent();
    Basic.add_clickEvent();
    History.add_event();

    if(document.body.dataset.load)
    {
        await Basic.load_backgroundPage(document.body.dataset.load);
    }

    // add oberservers etc.
    Basic.do_afterLoad();
});

// open details elements before print
window.addEventListener('beforeprint',() =>
{
    const allDetails = document.body.querySelectorAll('details');
    for(let i=0; i<allDetails.length; i++)
    {
        // mark details elements which are already open
        if(allDetails[i].open)
        {
            allDetails[i].dataset.open = '1';
        }
        // open details element
        else
        {
            allDetails[i].setAttribute('open', '');
        }
    }
});


// close details elements after print which were not open before
window.addEventListener('afterprint',() =>
{
    const allDetails = document.body.querySelectorAll('details');
    for(let i=0; i<allDetails.length; i++)
    {
        // remove marking
        if(allDetails[i].dataset.open)
        {
            allDetails[i].dataset.open = '';
        }
        // only close details elements which were not marked
        else
        {
            allDetails[i].removeAttribute('open');
        }
    }
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window resize detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});